import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../api/axios";
import domen from "../api/domen";

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async () => {
    const { data } = await axios.get("/api/shop/products");

    const products = data.map((p) => {
      const photo = p.photo.startsWith("http") ? p.photo : `${domen}${p.photo}`;
      return { ...p, photo };
    });

    const allPhotos = products.map((p) => p.photo).filter(Boolean);
    
    await Promise.all(
      allPhotos.map(
        (src) =>
          new Promise((res) => {
            const img = new Image();
            img.onload = res;
            img.onerror = res;
            img.src = src;
          })
      )
    );

    return products;
  }
);

const productsSlice = createSlice({
  name: "products",
  initialState: { list: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      }),
});

export default productsSlice.reducer;
